import { SpacerFragment } from '@lib/umbraco/generated/types.generated'
import React, { FC } from 'react'
import styles from './Spacer.module.scss'

type SpacerComponentProps = SpacerFragment
const SpacerComponent: FC<SpacerComponentProps> = ({
  height,
  color,
  hexColorPicker,
  anchorID,
}) => {
  return (
    <div
      data-module="Spacer"
      id={anchorID}
      suppressHydrationWarning
      style={
        {
          backgroundColor: hexColorPicker ?? `#${color}`,
          '--data-height': `${height}vh`,
        } as React.CSSProperties
      }
      className={styles.container}
    />
  )
}

export default SpacerComponent
